export const CREATE_VEHICLE = 'app/CREATE_VEHICLE';
export const UPDATE_VEHICLE = 'app/UPDATE_VEHICLE';
export const DELETE_VEHICLE = 'app/DELETE_VEHICLE';

export const FORM_NAME = 'HouseholdVehicles';
